import { Component } from '@angular/core';

@Component({
  selector: 'app-career-marketing',
  templateUrl: './career-marketing.component.html',
  styleUrls: ['./career-marketing.component.scss']
})
export class CareerMarketingComponent {

}
